/* eslint-disable no-undef, react/prop-types */
import React from 'react';
import { css } from 'react-emotion';
import Img from 'gatsby-image';
import Link from 'gatsby-link';
import { Box, Flex } from '../components/Layout';
import colors from '../utils/colors';
import media from '../utils/media';

const style = css`
  text-align: center;
  padding-bottom: 10%;
  margin-top: 3.5rem;
  color: ${colors.primary};
  & ul {
    list-style-type: none;
    color: ${colors.primary};
  }
  h1,
  h2 {
    margin-top: 0;
    padding-bottom: 0.5em;
  }
  p {
    margin-bottom: 1em;
  }
  min-width: 33.33%;
  order: 1;
  ${media.mid`
    min-width: 33.33%;
    order: 2;
  `};
`;

const linkStyle = css`
  color: ${colors.primary};
  text-decoration: underline;
  &:hover {
    text-decoration: none;
  }
`;

const flexStyle = css`
  margin-top: 3.5rem;
  height: 100%;
  flex-wrap: nowrap;
  flex-direction: column;
  justify-content: space-around;
  ${media.mid`
    flex-direction: row;
  `};
`;

const emptyColStyle = css`
  min-width: 33.33%;
  order: 3;
  min-height: 2em;
`;

const imgStyle = css`
  margin-right: auto;
  margin-left: auto;
  box-sizing: content-box;
  max-width: 70%;
`;

const outerImgWrapper = css`
  width: 8em;
  min-width: 60%;
  align-self: flex-end;
  order: 2;
  margin-left: auto;
  margin-right: auto;
  ${media.mid`
    min-width: 33.33%;
    order: 1;
    margin-right: 1em;
    margin-left: 2em;
    margin-right: 0;
    margin-bottom: 2em;
`};
`;

const fullHeight = css`
  min-height: 100%;
`;

const Liput = ({ data }) => {
  const { apteekkari } = data;
  return (
    <Box className={fullHeight}>
      <Flex className={flexStyle}>
        <Img
          className={imgStyle}
          outerWrapperClassName={outerImgWrapper}
          alt="Apteekkari, Kuvaaja: Inkeri Jäntti"
          sizes={apteekkari.childImageSharp.sizes}
          imgStyle={{
            objectFit: 'contain',
            width: '100%',
            height: 'auto',
            boxSizing: 'content-box'
          }}
        />
        <div className={style} color={colors.secondary}>
          <h2>Liput</h2>
          <ul>
            <li>Peruslippu 15 €</li>
            <li>S-etukortilla* 13 €</li>
            <li>Alle 10-vuotiaat 10 €</li>
          </ul>

          <p>
            <small>
              *S-etukortilla kahden euron alennus peruslipun hinnasta.
              <br />
              S-etukortti on esitettävä sekä oston että sisäänpääsyn yhteydessä.
            </small>
          </p>

          <h2>Lipunmyynti</h2>
          <p>
            Kulttuuritalo Valveen lippumyymälä<br />
            Hallituskatu 7, Oulu<br />
            Avoinna ke–su 12–19,<br />
            puh. (08) 5584 7575<br />
            (Ilman toimituskuluja)
          </p>
          <br />
          <Link
            className={linkStyle}
            href="https://www.ticketmaster.fi/search/?keyword=owla+ja+kadonnut+walkia"
            target="_blank"
            rel="noopener"
          >
            Ticketmaster.fi
          </Link>
          <p>
            Ticketmaster Suomen lippukaupat<br />(Lippukaupat perivät omat
            toimituskulunsa noudon yhteydessä.)
          </p>

          <h2>Tiedustelut</h2>
          <p>
            Tuottaja Hanna Poikela,{' '}
            <a href="mailto:hanna.poikela@gmail.com">hanna.poikela@gmail.com</a>
          </p>
        </div>
        <div className={emptyColStyle} />
      </Flex>
    </Box>
  );
};

export const query = graphql`
  query LiputtQuery {
    apteekkari: file(relativePath: { eq: "apteekkari_pose.png" }) {
      childImageSharp {
        sizes(maxWidth: 512) {
          ...GatsbyImageSharpSizes_noBase64
        }
      }
    }
  }
`;

export default Liput;



// WEBPACK FOOTER //
// ./src/pages/liput.js